import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./redux/store/index";
import "./index.css";
import App from "./App";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";
import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js